import React from 'react';
import Hero from '../components/Hero';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
    </div>
  );
};

export default Home;